import { useTranslation } from 'react-i18next';
import { DEFAULT_LOCALE, languageTag, normalizeLocale, type LanguageTag } from './constants';

/**
 * The active locale as its BCP-47 tag (`pt` → `pt-BR`), for the Intl formatters in `./format`.
 * Catalog and brand-copy lookups key on the bare locale: `normalizeLocale(useLocale())`.
 */
export function useLocale(): LanguageTag {
  const { i18n } = useTranslation();
  return languageTag(normalizeLocale(i18n.resolvedLanguage ?? i18n.language) ?? DEFAULT_LOCALE);
}
